import Vue from 'vue';
import Vuex from 'vuex';
import * as getters from './getters'
import * as actions from './actions'
import * as mutations from './mutations'

Vue.use(Vuex);

const state = {
	paymentMethodName: '',
	mPGSCardUsed: {},
	paymentMethod: '',
	paymentMethodIndex: '',
	client_info: {},
	app_info: {},
	payload: {},
	service_call_payload: {},
	options: {},
	api_key: null,
	isFailed: false,
	hasPaid: false,
	hasOtp: false,
	isLoading: true,
	channels: {},
	popupReferrer: null,
	provider: {},
	card_cc: '',
	card_exp: '',
	card_cvv: '',
	parentTransRef: '',
	paymentMethodProvider: '',
	optionsTransRef: '',
	transRef: '',
	showDefaultView: false,
	cardDetails: {
		card_cc: '',
		card_exp: '',
		card_cvv: '',
		card_pin: '',
	},
	customer_processing_fee: 0.00,
};

const store = new Vuex.Store({
	actions,
	getters,
	mutations,
	state
});

if (module.hot) { // Hot reload whenever any module changes.
	module.hot.accept([
		'./getters',
		'./actions',
		'./mutations'
	], () => {
		store.hotUpdate({
			getters: require('./getters'),
			actions: require('./actions'),
			mutations: require('./mutations')
		})
	})
}


export default store;